export const moduleConfig = {
    entityKey: 'reconciliation-reports',
    titles: {
        singular: 'Reconciliation Report',
        plural: 'Reconciliation Reports'
    }
}

export const initialSortState = {
    column: 'runStartedAt',
    direction: 'desc',
};
